import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';

import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';

import { MatSort } from '@angular/material/sort';

import { Subject, Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { ModalService } from 'src/app/common/modal/modal.service';
import { AppService } from 'src/app/app.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { SelectionModel } from '@angular/cdk/collections';
import { FormService } from '../../services/form.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';


@Component({
    selector: 'app-form-table-list',
    templateUrl: './form-table-list.component.html',
    styleUrls: ['./form-table-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormTableListComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() configData: typeDHLFormControls;
  @Input() frmGroup: UntypedFormGroup;
  @Input() searchData;
  @Input() pageNumSearch;
  @Input() isRateLookup = false;
  @Input() resultView = 'list';
  @Input() highValue = 0;
  @Input() value = 0;
  @Input() searchMessage;

  @Output() clearFilter = new EventEmitter();
  @Output() errorMessage = new EventEmitter();
  @Output() emitTableData = new EventEmitter();
  @ViewChild(MatMenuTrigger, {static: true, read: MatMenuTrigger}) trigger: MatMenuTrigger;

  // @ViewChild(MatSort, {static: true}) sort: MatSort;

  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading: boolean = false;
  durationInSeconds = 20;
  restrictedData;
  currentLoadData;
  showLoadMoreLabel = false;
  pageSize: number = 50;
  pageNumber:number = 0;
  pageNo = 0;
  indexNum: any;
  listView: boolean = false;
 

  setSpinner() {
    this.isLoading = true;
    document.getElementById("overlay-table").style.display = "block";
  }
  removeSpinner() {
    this.normalView();
    this.isLoading = false;
  }
  normalView() {
    document.getElementById("overlay-table").style.display = "none";
  }

  dataSource: MatTableDataSource<NewOrder>;

  newDisplayedColumns = [];
  tableData: NewOrder[] = [];
  tableMetaData;
  tabelConfig;
  serverError: String;
  
  constructor(private formService: FormService, private modalService: ModalService, public matDialog: MatDialog, private router: Router, private appService: AppService, private _snackBar: CustomSnackBarService) {
    this.tabelConfig = this.appService.getSearchResultMetaData();
  }
  confirmDlg: MatDialogRef<ModalComponent>;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchData'] && this.searchData !== undefined) {
      this.serverError = '';
      this.showLoadMoreLabel = false;
      this.pageNumber = this.pageNumber ? this.pageNumSearch : this.pageNumber;
      let newArr = [];
      let sourceNodeName = '';
      if (this.httpConfig) {
        sourceNodeName = this.httpConfig.sourceNodeName;
      }

      if (this.searchData.length > 0) {

        if (sourceNodeName == 'orders') {
          this.tableData = this.formatOrderListData(this.searchData);
        } else {
          this.searchData.forEach(user => {
            user.userCustomerSubscriptionList.forEach(sub => {
              let usr = Object.assign({}, user);
              usr.userRole = sub.userRole;
              usr.secondaryUserRoles = sub.secondaryUserRoles;
              usr.customerCode = sub.customerCode;
              //usr.dataRestrictions = sub.dataRestrictions;
              usr.userCustomerSubscriptionList = sub;
              if(sub['dataRestrictions'] && typeof sub['dataRestrictions'] === 'object' ){
                usr.dataRestrictions = '';
                for (const dataRestriction in sub.dataRestrictions) {
                  usr.dataRestrictions += `${dataRestriction}: ${sub.dataRestrictions[dataRestriction]}<br>`;
                }
              } else {
                usr.dataRestrictions = sub.dataRestrictions;
              }
              newArr.push(usr);
            })
          });
          this.tableData = newArr;
        }

        this.searchData = this.formatOrderListData(this.tableData);

        this.addSortingFeature();

        // this.dataSource.sort = this.sort;
        // let columnToBeSort;
        // this.dataSource.sortingDataAccessor = (item, property) => {
        //   switch (property) {
        //     default: {
        //       this.tabelConfig.TableHeaders.some(column => {
        //         if (property === column.title) {
        //           if (column['sortColumnAttribute'] instanceof Object)
        //             columnToBeSort = column.sortColumnAttribute.key;
        //           else
        //             columnToBeSort = column.sortColumnAttribute;
        //           return true;
        //         } else {
        //           columnToBeSort = null;
        //           return false;
        //         }
        //       });
        //       return item[columnToBeSort];
        //     }
        //   }
        // }

      }
      this.dataSource = new MatTableDataSource(this.searchData);
    }
    if ((this.searchMessage !== undefined && this.searchData.length < 1) || (this.searchMessage !== undefined && this.searchData === undefined)) {
      this.serverError = this.searchMessage;
    }
  }

  formatOrderListData(orders) {
    let primaryText = '';
    let secondaryText = '';
    let number = 0;
    orders.map(data => {
      this.tabelConfig.TableHeaders.some(columnList => {
        if (columnList['sortColumnAttribute'] instanceof Object)
          if (columnList['sortColumnAttribute'].type == 'integer' && data[columnList['sortColumnAttribute'].key])
            data[columnList['sortColumnAttribute'].key] = parseInt(data[columnList['sortColumnAttribute'].key]);
        if (columnList['primaryText'].configure) {
          let restrictDecimal = columnList['restrictDecimalPlaces'];
          let ps = this.configureColumnData(restrictDecimal, columnList, data);
          if (ps) {
            primaryText = ps.p ?? "";
            secondaryText = ps.s ?? "";
            data[columnList['primaryText'].key] = primaryText;
            data[columnList['secondaryText'].key] = secondaryText;
          }
        } else {
          if(columnList['primaryText'].value.length > 0) {
            columnList['primaryText'].value.forEach(col1 => {
              if (primaryText.length > 0) {
                if (columnList['primaryText'].value.length > 2)
                  primaryText += ', ';
                else
                  primaryText += ' ';
              }
              if (columnList['primaryText'].multipleNode) {
                let node = col1.split(',');
                let value;
                for (var x in node) {
                  if (value)
                    value = value[node[x]];
                  else
                    value = data[node[x]];
                }
                primaryText += value;
              } else {
                if (col1 === 'serialNumber')
                  primaryText += ++number;
                else
                  primaryText += data[col1];
              }
              if (columnList['restrictDecimalPlaces']) {
                primaryText = parseFloat(primaryText).toFixed(columnList['restrictDecimalPlaces']);
              }
            })
            if (columnList['primaryText'].suffixValue && columnList['primaryText'].multipleNode) {
              let suffix = columnList['primaryText'].suffixValue.split(',');
              let v;
              for (let s in suffix) {
                if (v)
                  v = v[suffix[s]]
                else
                  v = data[suffix[s]]
              }
              primaryText += ' ' + v;
            }
          }
          if (columnList['secondaryText'].value.length > 0) {
            columnList['secondaryText'].value.forEach(col2 => {
              if (secondaryText.length > 0) {
                if (columnList['secondaryText'].value.length > 2)
                  secondaryText += ', ';
                else
                  secondaryText += ' ';
              }
              if (columnList['secondaryText'].multipleNode) {
                let nodeS = col2.split(',');
                let valueS;
                for (var x in nodeS) {
                  if (valueS)
                    valueS = valueS[nodeS[x]];
                  else
                    valueS = data[nodeS[x]];
                }
                secondaryText += valueS;
              } else
                secondaryText += data[col2];
            })
          }
          if (columnList['primaryText'].suffix && primaryText)
            primaryText += ' ' + columnList['primaryText'].suffix;
          if (columnList['secondaryText'].suffix && secondaryText)
            secondaryText += ' ' + columnList['secondaryText'].suffix;

          data[columnList['primaryText'].key] = primaryText;
          data[columnList['secondaryText'].key] = secondaryText;

          // start sorting on raw value
          let raw;
          raw = primaryText.split(" ")[0];
          if(columnList['sortColumnAttribute'].type === 'integer')
            raw = parseInt(raw)
          data["raw_" + columnList['primaryText'].key] = raw;
          // end sorting on raw value

          // if (columnList['primaryText'].type == 'date') {
          //   if (data[columnList['primaryText'].value[0]]) {
          //     let date = new Date(data[columnList['primaryText'].value[0]]);
          //     data[columnList['primaryText'].key] = this.formatDate(date);
          //   }
          // }
        }
        primaryText = '';
        secondaryText = '';
      });
    }, this)
    return orders;
  }

  formatDate(rawDate) {
    let month = rawDate.getMonth() + 1;
    let date = rawDate.getDate();
    let year = rawDate.getFullYear();
    let hours = rawDate.getHours();
    let minutes = rawDate.getMinutes();

    month = month < 10 ? '0' + month : month;
    date = date < 10 ? '0' + date : date;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return month + '-' + date + '-' + year + ' ' + hours + ':' + minutes;
  }

  getInitialOrdersList() {
    this.showLoadMoreLabel = false;
    this.isLoading = true;
    let httpConfig = this.tabelConfig.httpConfig;
    let requst: Observable<any>;
    document.getElementById("overlay-table").style.display = "block";
    let url = httpConfig.dataSource || APP_Constants.SEARCH_ORDER_DATA;
    // let url = "/allBulkUserDummyData";
    let sourceNodeName = httpConfig.sourceNodeName;
    // if(this.configData. ){

    // }
    // this.appService.ordersSearchListData(APP_Constants.SEARCH_ORDER_DATA+sessionStorage.getItem('customerCode')+
    if (httpConfig.method == 'GET') {
      this.pageNumber =this.pageNumber+1;
      // let url= '/template/allUserDummyData'
      let url = APP_Constants.ADMIN_ALL_USERS_URI;
      url += localStorage.getItem('userName');
      url += "&pageSize=" + this.pageSize + "&pageNumber=" + this.pageNumber;
      url += '&searchUserName=' +  (sessionStorage.getItem(sourceNodeName)? sessionStorage.getItem(sourceNodeName):"");
      requst = this.appService.makeHttpGetRequest(url,);
      // requst = this.appService.makeLocalOrderSearchHNA(url,);

    } else {
      requst = this.appService.makeHttpPostRequest(url, {});
    }
    requst.subscribe(data => {
      this.normalView();
      this.isLoading = false;
      if (data['message'].statusCode === APP_Constants.SUCCESS_CODE) {

        // this.tableData = data['orders'];
        // this.tableData = this.formatOrderListData(data['orders']);
        if (sourceNodeName == 'orders') {
          this.tableData = this.formatOrderListData(data[sourceNodeName]);
        }
        else if(sourceNodeName == 'bulkUsers') {
          let newArr = [];
          data['data'].historyData.forEach(user => {
              newArr.push(user);
          });
          this.tableData = this.formatOrderListData(newArr);
        }
         else {
          let newArr = [];
          data['data'].userdata.forEach(user => {
            user.userCustomerSubscriptionList.forEach(sub => {
              let usr = Object.assign({}, user);
              usr.userRole = sub.userRole;
              usr.secondaryUserRoles = sub.secondaryUserRoles;
              usr.customerCode = sub.customerCode;
              //usr.dataRestrictions = sub.dataRestrictions;
              if (sub?.dataRestrictions && typeof sub?.dataRestrictions === 'object') {
                usr.dataRestrictions = '';
                for (const dataRestriction in sub.dataRestrictions) {
                  usr.dataRestrictions += `${dataRestriction}: ${sub.dataRestrictions[dataRestriction]}<br>`;
                }
              } else {
                usr.dataRestrictions = sub.dataRestrictions;
              }
              usr.userCustomerSubscriptionList = sub;
              newArr.push(usr);
            })
          });
          if (this.tableData.length >= (this.tabelConfig.maxRows || 5)) {
            this.tableData = this.tableData.concat(this.formatOrderListData(newArr));
          } else {
            this.tableData = this.formatOrderListData(newArr);
          }
        }
        this.dataSource = new MatTableDataSource(this.tableData);

        this.addSortingFeature()
        // write seperate method for sorting
        // this.dataSource.sort = this.sort;
        // let columnToBeSort;
        // this.dataSource.sortingDataAccessor = (item, property) => {
        //   switch (property) {
        //     default: {
        //       this.tabelConfig.TableHeaders.some(column => {
        //         if (property === column.title) {
        //           if (column['sortColumnAttribute'] instanceof Object)
        //             columnToBeSort = column.sortColumnAttribute.key;
        //           else
        //             columnToBeSort = column.sortColumnAttribute;
        //           return true;
        //         } else {
        //           columnToBeSort = null;
        //           return false;
        //         }
        //       });
        //       return item[columnToBeSort];
        //     }
        //   }
        // }
      } else if (data['message'].statusCode == APP_Constants.ERROR_CODE) {
        this.serverError = data['message'].statusMessage;

      }
    },
      err => {
        this.normalView();
        this.isLoading = false;

        let modal = new Modal({
          action: false, name: 'Orders', title: ModalConfigData.TITLES.ORDERS, description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
  }

  xPosition;
  @ViewChild(MatSort, { static: true }) sort: MatSort;


  httpConfig;
  ngOnInit() {
    if(this.checkInitFromParent()){
      return
    }
    this.tabelConfig = this.appService.getSearchResultMetaData();
    this.httpConfig = this.tabelConfig.httpConfig;
    if (this.httpConfig.serviceData) {
      let rateLookupResponse = this.appService.getRateLookupResult();
      if(rateLookupResponse) {
        if(rateLookupResponse['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          if(!Array.isArray(rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult)){
            rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult = [
              rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult
            ]
          }
          this.tableData = this.formatOrderListData(rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult);
          if (this.isRateLookup) {
            this.emitTableData.emit(this.tableData);
          }
          // if (this.isRateLookup && (this.value || this.highValue)) {
          //   this.tableData = this.tableData.filter(
          //     data => data.Cost.FinancialAmount.MonetaryAmount >= this.value && data.Cost.FinancialAmount.MonetaryAmount <= this.highValue);
          // }
          this.dataSource = new MatTableDataSource(this.tableData);
          this.addSortingFeature();
        } else {
          this.serverError = rateLookupResponse['message'].statusMessage;
        }
      }
    } else {
      this.getInitialOrdersList();
    }


    let note = document.getElementById('table-orders');
    let screenPosition = note.getBoundingClientRect();
    this.xPosition = screenPosition['x'];

    this.tabelConfig.TableHeaders.forEach(element => {
      this.newDisplayedColumns.push(element.title);
    });

    this.appService._commonComponentSubject.next({
      component: this,
      configData: this.configData,
      data: this.tableData
    });
  }

  ngAfterViewInit() {
    let tableCard = document.getElementById('table-orders');
    let tableOverlay = document.getElementById('overlay-table');
    tableOverlay.style.width = tableCard.offsetWidth + 'px';
  }

  checkInitFromParent(){
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'init');
    if (event) {
      let event = this.configData.events.filter(ele => ele.event == 'init');
      if (event && event.length) {
        let note = document.getElementById('table-orders');
        let screenPosition = note.getBoundingClientRect();
        this.xPosition = screenPosition['x'];
        this.appService._commonComponentSubject.next({
          component: this,
          configData: this.configData,
          event: event[0].event,
          eventData: event[0],
          action: event[0].action,
          name: this.configData.name
        });
        return true
      }else {
        return false;
      }
    }else {
      return false;
    }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, row = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  onRowClickHandler(data) {
    if (data.OrderPrimaryText) {
      this.appService.setOrderDetails(data);
      localStorage.setItem('orderType', data.ORDER_RELEASE_TYPE);
      this.router.navigate(['/orders', data.OrderPrimaryText]);
      localStorage.removeItem('TotalPoLinesSelected');
    } else {
      let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'ROW_CLICK');
      if (event) {
        this.sendToSource(event, data);
      }
    }

  }
  filterTableData(data) {
    this.dataSource.filter = data.trim().toLowerCase();
  }

  performAction(e, name, orderData, config, action) {
    e.stopPropagation();
    switch (name) {
      case 'editUser': {
        if(this.trigger) this.trigger.closeMenu();
        e.stopPropagation();
          this.onEditUser(name, orderData, config, action);
        break;
      }
      case 'removeUser': {
        e.stopPropagation();
        this.onRemoveUser(name, orderData, config)
        break;
      }
    }
    if (name === 'Cancel') {

      this.isLoading = true;
      document.getElementById("overlay-table").style.display = "block";

      let orderType = orderData.ORDER_RELEASE_TYPE;
      let apiUrl;
      let transmissionUrl;

      if (orderType === "TOP-ORDER_RELEASE") {
        apiUrl = APP_Constants.RELEASE_CANCEL_ORDER_LINK + localStorage.getItem('customerCode') +
          '&releaseId=' + orderData.ORDER_RELEASE_XID +
          '&userId=' + localStorage.getItem('userName');

        transmissionUrl = APP_Constants.RELEASE_CANCEL_ORDER_TRANSMISSION_STATUS + localStorage.getItem('customerCode') +
          '&orderId=' + orderData['ORDER_RELEASE_XID'] +
          '&userId=' + localStorage.getItem('userName');

      } else {
        apiUrl = APP_Constants.CANCEL_ORDER_LINK + localStorage.getItem('customerCode') +
          '&orderId=' + orderData.ORDER_RELEASE_XID +
          '&orderBaseId=' + orderData.ORDER_BASE_XID +
          '&userId=' + localStorage.getItem('userName');

        transmissionUrl = APP_Constants.CANCEL_ORDER_TRANSMISSION_STATUS + localStorage.getItem('customerCode') +
          '&orderId=' + orderData.ORDER_BASE_XID + '&userId=' + localStorage.getItem('userName');
      }

      let config = {
        actions: false,
        name: 'cancel',
        title: 'Cancel Order',
        description: "",
        actionButtonText: ''
      }

      this.appService.makeHttpPostRequest(apiUrl,
        {})
        .subscribe(data => {
          if (data['message'].statusCode === 'SUCCESS') {
            let times = 0;
            let transmissionStatus;
            setTimeout(() => {
              this.appService.makeHttpGetRequest(transmissionUrl +
                '&transmissionNo=' + data['transmissionNo']
              ).subscribe(
                data => {
                  transmissionStatus = data;
                  if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                    this.normalView();
                    this.isLoading = false;
                    this.getInitialOrdersList();
                    this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                    this.router.navigateByUrl('/orders');
                    localStorage.removeItem('TotalPoLinesSelected');
                    localStorage.removeItem('ResetPoSelected');
                  }
                }, err => {
                  this.normalView();
                  this.isLoading = false;

                  let modal = new Modal({
                    action: false, name: 'orderStatus', title: ModalConfigData.TITLES.ORDERSTATUS, description: err.message, actionButtonText: ''
                  });
                  this.modalService.createModalBox(modal, err.status);
                });

              let intervalId = setInterval(() => {
                if (
                  transmissionStatus &&
                  (
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE
                  )) {
                  clearInterval(intervalId);
                  this.normalView();
                  this.isLoading = false;

                } else if (++times == 5 && transmissionStatus && (transmissionStatus['statusCode']?.toUpperCase() || transmissionStatus['message']?.statusCode?.toUpperCase()) === APP_Constants.IN_PROGRESS_CODE) {
                  this.getInitialOrdersList();
                  this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                  this.router.navigateByUrl('/orders');
                  localStorage.removeItem('TotalPoLinesSelected');
                  localStorage.removeItem('ResetPoSelected');
                  clearInterval(intervalId);
                } else {
                  this.appService.makeHttpGetRequest(transmissionUrl +
                    '&transmissionNo=' + data['transmissionNo']
                  ).subscribe(
                    data => {
                      transmissionStatus = data;
                      if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                        transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                        this.normalView();
                        this.isLoading = false;
                        this.getInitialOrdersList();
                        this._snackBar.open({ orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
                        this.router.navigateByUrl('/orders');
                        localStorage.removeItem('TotalPoLinesSelected');
                        localStorage.removeItem('ResetPoSelected');
                      }
                    }, err => {
                      this.normalView();
                      this.isLoading = false;

                      let modal = new Modal({
                        action: false, name: 'orderStatus', title: ModalConfigData.TITLES.ORDERSTATUS, description: err.message, actionButtonText: ''
                      });
                      this.modalService.createModalBox(modal, err.status);
                    });
                }
              }, 3000);

            }, 1000);

          } else if (data['message'].statusCode === 'ERROR') {
            this.normalView();
            this.isLoading = false;
            let errormsg = this.appService.errorHandling(data['message']);
            let modal = new Modal({
              action: false, name: 'orderCancelInvalid', title: ModalConfigData.TITLES.ORDERCANCEL, description: errormsg, actionButtonText: ''
            });
            this.modalService.createModalBox(modal, data['message'].statusCode);

          } else if (data['message'].statusCode === 'FAILED') {
            this.normalView();
            this.isLoading = false;
            this._snackBar.open(data['message'].statusMessage, { duration: this.durationInSeconds * 1000 });
          }
        }, err => {
          this.normalView();
          this.isLoading = false;

          let modal = new Modal({
            action: false, name: 'orderCancel', title: ModalConfigData.TITLES.ORDERCANCEL, description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);
        });

    }
    else if (name === 'document') {
      e.stopPropagation();

      this.isLoading = true;
      document.getElementById("overlay-table").style.display = "block";
      document.getElementById("overlay-table").style.backgroundColor = "transparent";

      // let url = APP_Constants.FETCH_DOCUMENT_URL + 'TOP20062300011&customerCode=HNA&userId=abc&action=SHIPPING_DOCUMENT_STATUS_CHECK';
      let url = '';

      if (config.command.ajax) {
        url = config.command.url + orderData.ORDER_RELEASE_XID + '&customerCode=' + localStorage.getItem('customerCode') +
          '&userId=' + localStorage.getItem('userName');
      }
      this.appService.makeHttpDocRequest(url).subscribe((data: any) => {
        document.getElementById("overlay-table").style.backgroundColor = "#fff";
        this.normalView();
        this.isLoading = false;

        FileSaver.saveAs(data, orderData.ORDER_RELEASE_XID + ".pdf");

        // let blob = new Blob([data], { type: "application/pdf" });

        // var downloadURL = window.URL.createObjectURL(blob);
        // var link = document.createElement('a');
        // link.href = downloadURL;
        // link.download = orderData.ORDER_RELEASE_XID+".pdf";
        // link.click();

      }, async (err) => {

        document.getElementById("overlay-table").style.backgroundColor = "#fff";

        this.normalView();
        this.isLoading = false;

        const message = JSON.parse(await err.error.text()).message.statusMessage;

        let modal = new Modal({
          action: false, name: 'document', title: 'Document', description: message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      })
    }
    else if (name === 'Edit'){
      this.onRowClickHandler(orderData);
    }
  }

  onEditUser(name, userData, config, action) {
    if(this.trigger) this.trigger.closeMenu();
    let controls = config.controls;

    userData = Object.assign({}, userData);
    let dataRestrictionObj =  userData?.userCustomerSubscriptionList?.dataRestrictions;
    let dataRestrictionsKey = []
    if(dataRestrictionObj){
      dataRestrictionsKey = Object.keys(dataRestrictionObj);
    };
    controls.filter((resdata, index) => {
      if (resdata.name == 'secondaryUserRoles') {
        if (!userData.userCustomerSubscriptionList.secondaryUserRoles) {
          resdata.disabled = true;
          resdata.hidden = true;
        }
      }
      if (dataRestrictionObj && dataRestrictionsKey.length > 0 && dataRestrictionsKey.includes(resdata.name)) {
        controls.splice(index, 1);
      } else if (resdata.name == 'dataRestrictions') {
        controls.splice(index, 1);
      }
    });

    let editUserformGroup: UntypedFormGroup = this.formService.createForm({ controls: controls });
    userData.userRole = { displayValue: userData.userRole, value: userData.userRole };

    // console.log(editUserformGroup,'<===editUserformGroup');
    // if(userData.userRole.value == "Vendor")
    // {
    //   userData.secondaryUserRoles = "";
    // }
    // else
    // {
    //   userData.secondaryUserRoles = { displayValue: userData.secondaryUserRoles, value: userData.secondaryUserRoles };
    // }

    userData.secondaryUserRoles = { displayValue: userData.secondaryUserRoles, value: userData.secondaryUserRoles ? userData.secondaryUserRoles : '' };

    // userData.parameterId = userData.userCustomerSubscriptionList.parameterId || "vendor_number";    // hard-coded, fix from back end
    // userData.parameterValue = userData.userCustomerSubscriptionList.parameterValue;

    if (editUserformGroup.get('secondaryUserRoles')) {
      editUserformGroup.get("secondaryUserRoles")['hidden'] = true;
    }

    editUserformGroup.patchValue(userData);

    let dataRestrictionsObj = userData?.userCustomerSubscriptionList?.dataRestrictions;
    if (dataRestrictionsObj && typeof dataRestrictionsObj === 'object') {
      for (const dataRestrictionKey in dataRestrictionsObj) {
        const value = dataRestrictionsObj[dataRestrictionKey];
        setTimeout(() => {
          editUserformGroup.get(dataRestrictionKey).setValue(value);
        })
      }
    } else if (userData.dataRestrictions) {
      setTimeout(() => {
        editUserformGroup.get('dataRestrictions').setValue(userData.dataRestrictions);
      })
    }

    let modal = new Modal({
      action: false, name: 'editOrder', title: 'Edit User', description: 'User Edit form', actionButtonText: '',
      modalForm: { modalName: 'editUserModalForm', template: config, frmGroup: editUserformGroup, editMode: true }
    });

    this.modalService.createModalBox(modal, 200);

    let sub = this.appService._commonSubjecct.subscribe((response) => {
      this.clearFilter.emit({});
      sub.unsubscribe();
    })
  }

  onRemoveUser(name, orderData, config) {
    let modalConfigObj = {
      actions: true,
      name: "Confirm",
      title: "Remove User?",
      description: "Would you like remove user?",
      actionButtonText: "Remove"
    }
    const subject = new Subject<boolean>();
    let modalConfig: MatDialogConfig<any> = new ModalConfig(modalConfigObj);
    this.confirmDlg = this.matDialog.open(ModalComponent, modalConfig);
    this.confirmDlg.componentInstance.subject = subject;
    this.confirmDlg.afterClosed().subscribe(async response => {
      if (response) {
        this.onRemoveUserPromptSuccess(orderData);
        return true;
      } else {
        return false;
      }
    });
  }

  onRemoveUserPromptSuccess(orderData) {
    let url = APP_Constants.ADMIN_REMOVE_USER_URI + localStorage.getItem('userName');
    let payload = { "userId": orderData.userName };
    this.appService.makeHttpPutRequest(url, payload).subscribe((response: any) => {
      if (response['message']['statusCode'] == APP_Constants.SUCCESS_CODE) {
        this._snackBar.open({ orderId: '', message: response['message']['statusMessage'] }, { duration: this.durationInSeconds * 1000 });
        this.getInitialOrdersList();
        this.clearFilter.emit({});
      }
    }, (err) => {
      this._snackBar.open({ orderId: '', message: err['message'] }, { duration: this.durationInSeconds * 1000 });
    });
  }

  checkScroll(events) {
    let headerFixedHolder = document.getElementById('table-orders');
    let left = headerFixedHolder.scrollLeft;
    let myElements = document.querySelectorAll(".action-icons");

    for (let i = 0; i < myElements.length; i++) {
      if (left == 0) {
        myElements[i]['style'].right = 0
      } else {
        myElements[i]['style'].right = '-' + left.toString() + 'px';
      }
    }
    if ((this.currentLoadData && this.currentLoadData.length > (this.tabelConfig.maxRows - 1) ) || (this.tableData.length < (this.tabelConfig.maxRows * this.tabelConfig.scrollLimit))) {
      if (this.tabelConfig.incrementalLoadWhenScrolling) {
        if ((Math.round(events.target.offsetHeight + events.target.scrollTop) + 1 ) >= events.target.scrollHeight) {
          this.pageNo = this.pageNo + 1;
          if (this.tabelConfig.showDefaultLoadMore && this.tableData.length >= this.tabelConfig.maxRows && (this.tableData.length % this.tabelConfig.maxRows === 0)) {
            this.showLoadMoreLabel = true;
          }
          // alert(this.pageNo+'this.pageNo');
          let eventsForLoadChunks: DhlFormControlEvent = { eventConfig: {}, action: "LOAD_DATA_UPLOAD_CHUNKS", event: "chunks" }
          this.sendToSource(eventsForLoadChunks, this.pageNo)
        }
      }
    }
  }


  // new table changes
  selection = new SelectionModel<NewOrder>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: NewOrder): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
  }

  //minutes to hour (and days) converter
  ConvertMinutes(num) {
    let d = Math.floor(num / 24); // 60*24
    let h = Math.floor((num - (d * 24)));
    //calculating remaining hr to calculate minutes
    let minutesInHrs = (num - (h + (d * 24)));
    let m = Math.floor(minutesInHrs * 60);

    if (d > 0) {
      return (d + (d == 1 ? " day, ": " days, ")  + h + " hrs, " + m + " mins");
    } else {
      return (h + " hrs, " + m + " mins");
    }
  }


  configureColumnData(restrictDecimal, primaryData, data) {
    let rateCriteria = this.appService.getRateLookupEnquiry();
    let costA = 0;
    let costB = 0;
    let costSum = 0;
    let costUnit = '';
    let primaryText = '';
    let secondaryText = '';
    if (primaryData['primaryText'].key == 'equipment' && data?.EquipmentGroupGid) {
      let node = data["EquipmentGroupGid"].Gid.Xid;
      let val = this.configData['config']['equipment'][node];
      return { p: val, s: "" };
    }
    else if (primaryData['primaryText'].key == 'transportMode' && data?.TransportModeGid) {
      let node = data["TransportModeGid"].Gid.Xid;
      let val = this.configData['config']['mode'][node];
      return { p: node, s: "" };
    }
    else if (primaryData['primaryText'].key == 'transit' && data?.TransitTime) {
      let node = data["TransitTime"].Duration.DurationValue;

      data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(node.toString(), primaryData);

      let val = this.ConvertMinutes(node);
      return { p: val, s: "" };
    }else if(primaryData['primaryText'].key == 'primary'){
      let pathValue = primaryData['primaryText'].value;
      let row = (Array.isArray(data[pathValue[0]]) ? data[pathValue[0]][0] : data[pathValue[0]])
      let node = this.getValueRecursion(row, pathValue.slice(1));
      return { p: (node == 'PREFERRED_RATE' ? 'Y' : 'N'), s: "" };
    }
    else if (primaryData['primaryText'].key === 'linehaulCostPrimary' || primaryData['primaryText'].key === 'linehaulCostSecondary') {
      if (data['CostDetails'] instanceof Array) {
        data['CostDetails'].forEach(a => {
          if (a['Cost']) {
            costUnit = a['Cost'].FinancialAmount.GlobalCurrencyCode;
            if (a['CostType'] === 'B') {
              costA += parseFloat(a['Cost'].FinancialAmount.MonetaryAmount);
            }
            if (a['CostType'] === 'D') {
              costB += parseFloat(a['Cost'].FinancialAmount.MonetaryAmount);
            }
          }
        })

        if (restrictDecimal) {
          costA = parseFloat(costA.toFixed(restrictDecimal));
          costB = parseFloat(costB.toFixed(restrictDecimal));
          costSum = costA + costB;
          costSum = parseFloat(costSum.toFixed(restrictDecimal));
        }
        if (costSum > 0) {
          primaryText = costSum + ' ' + costUnit;
          if (costA)
            secondaryText = 'Base: ' + costA + ' ' + costUnit;
          if (costB) {
            secondaryText += ' \n';
            secondaryText += 'Discount:' + costB + ' ' + costUnit;
          }
        }
        data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(primaryText, primaryData);
        return { p: primaryText, s: secondaryText };
      }
      else {
        if (data['CostDetails'].Cost) {
          costA = parseFloat(data['CostDetails'].Cost.FinancialAmount.MonetaryAmount);
          costUnit = data['CostDetails'].Cost.FinancialAmount.GlobalCurrencyCode;
          if (costA) {
            if (restrictDecimal) {
              costA = parseFloat(costA.toFixed(restrictDecimal));
            }
            primaryText = costA + ' ' + costUnit;
            if (data['CostDetails'].CostType == 'B')
              secondaryText = 'Base: ' + costA + ' ' + costUnit;
            if (data['CostDetails'].CostType == 'D') {
              secondaryText += ', ';
              secondaryText += 'Discount: ' + costA + ' ' + costUnit;
            }
          }
        }
        data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(primaryText, primaryData);
        return { p: primaryText, s: secondaryText };;
      }
    }
    else if (primaryData['primaryText'].key === 'accessorialCostPrimary' || primaryData['primaryText'].key === 'accessorialCostSecondary') {
      let costF = 0;
      let costO = 0;
      let costG = 0;
      if (data['CostDetails'] instanceof Array) {
        data['CostDetails'].forEach(a => {
          if (a['Cost'] && a['CostType'] === 'A') {
            costUnit = a['Cost'].FinancialAmount.GlobalCurrencyCode;
            costA += parseFloat(a['Cost'].FinancialAmount.MonetaryAmount);
            if (a['AccessorialCodeGid'].Gid.Xid === 'FUE') {
              costF += parseFloat(a['Cost'].FinancialAmount.MonetaryAmount);
            }
            else if (a['AccessorialCodeGid'].Gid.Xid === primaryData.fuelSurchargeKey) 
            {
              costG += parseFloat(a['Cost'].FinancialAmount.MonetaryAmount);
            }
            else {
              costO += parseFloat(a['Cost'].FinancialAmount.MonetaryAmount);
            }
          }
        })
        if (restrictDecimal) {
          costA = parseFloat(costA.toFixed(restrictDecimal));
          costF = parseFloat(costF.toFixed(restrictDecimal));
          costO = parseFloat(costO.toFixed(restrictDecimal));
        }
        if (costA) {
          primaryText = costA + ' ' + costUnit;
        }
        if (costF)
          secondaryText = 'FUE: ' + costF + ' ' + costUnit;

        if(costG)
        {
          secondaryText = primaryData.fuelSurchargeKey + ':' + costG + ' ' + costUnit;
        }
        if (costO) {
          if (costF || costG)
            secondaryText += ' \n';
          secondaryText += 'Others: ' + costO + ' ' + costUnit;
        }
        data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(primaryText, primaryData);
        return { p: primaryText, s: secondaryText };
      }
      else {
        if (data['CostDetails'].Cost && data['CostDetails'].CostType === 'A') {
          costA = parseFloat(data['CostDetails'].Cost.FinancialAmount.MonetaryAmount);
          costUnit = data['CostDetails'].Cost.FinancialAmount.GlobalCurrencyCode;
          if (data['CostDetails']['AccessorialCodeGid'].Gid.Xid === 'FUE') {
            costF += parseFloat(data['CostDetails']['Cost'].FinancialAmount.MonetaryAmount);
          }
          else {
            costO += parseFloat(data['CostDetails']['Cost'].FinancialAmount.MonetaryAmount);
          }
          if (costA) {
            if (restrictDecimal) {
              costA = parseFloat(costA.toFixed(restrictDecimal));
              costF = parseFloat(costF.toFixed(restrictDecimal));
              costO = parseFloat(costO.toFixed(restrictDecimal));
            }
            primaryText = costA + ' ' + costUnit;

            if (costF)
              secondaryText = 'Fuel: ' + costF + ' ' + costUnit;
            if (costO) {
              if (costF)
                secondaryText += ', ';
              secondaryText += 'Others: ' + costO + ' ' + costUnit;
            }

          }
        }
        data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(primaryText, primaryData);
        return { p: primaryText, s: secondaryText };
      }
    }
    else if (primaryData['primaryText'].key === 'totalCost') {

      let node = primaryData['primaryText'].value[0].split(',');
      let va;
      for (var x in node) {
        if (va)
          va = va[node[x]];
        else
          va = data[node[x]];
      }
      costA += va;

      if (restrictDecimal) {
        costA = parseFloat(parseFloat(costA.toString()).toFixed(restrictDecimal));
      }

      if (primaryData['primaryText'].suffixValue && primaryData['primaryText'].multipleNode) {
        let suffix = primaryData['primaryText'].suffixValue.split(',');
        let v;
        for (let s in suffix) {
          if (v)
            v = v[suffix[s]]
          else
            v = data[suffix[s]]
        }
        primaryText = costA + ' ' + v;
      }
      data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(primaryText, primaryData);
      return { p: primaryText, s: secondaryText };
    }
    else if (primaryData['primaryText'].key === 'totalCostPlusMarkup') {
      let node = primaryData['primaryText'].value[0].split(',');
      let va;
      for (var x in node) {
        if (va)
          va = va[node[x]];
        else
          va = data[node[x]];
      }
      costA += va;
      if (rateCriteria['markUp']) {
        let margin = costA * (parseFloat(rateCriteria['markUp']) / 100);
        costA = parseFloat(costA.toString()) + margin;
      } else {
        return { p: null, s: null };
      }

      if (restrictDecimal) {
        costA = parseFloat(parseFloat(costA.toString()).toFixed(restrictDecimal));
      }

      if (primaryData['primaryText'].suffixValue && primaryData['primaryText'].multipleNode) {
        let suffix = primaryData['primaryText'].suffixValue.split(',');
        let v;
        for (let s in suffix) {
          if (v)
            v = v[suffix[s]]
          else
            v = data[suffix[s]]
        }
        primaryText = costA + ' ' + v;
      }
      data["raw_" + primaryData['primaryText'].key] =  this.storeRawValue(primaryText, primaryData);
      return { p: primaryText, s: secondaryText };
    }
  }

  getValueRecursion(data, pathArr){
    if(!pathArr.length){
      return data;
    }
    if(!data[pathArr[0]]){
      return null;
    }else {
      return this.getValueRecursion(data[pathArr[0]], pathArr.slice(1));
    }
  }
  updateTableList(lowValue,highValue)
  {
    let rateLookupResponse = this.appService.getRateLookupResult();
      if (rateLookupResponse) {
        if (rateLookupResponse['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          if(!Array.isArray(rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult)){
            rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult = [
              rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult
            ]
          }
          this.tableData = this.formatOrderListData(rateLookupResponse.data.response.RemoteQueryReply.RIQQueryReply.RIQResult);
          this.tableData = this.tableData.filter(
          data => data.Cost.FinancialAmount.MonetaryAmount >= lowValue && data.Cost.FinancialAmount.MonetaryAmount <= highValue);
          this.dataSource = new MatTableDataSource(this.tableData);
          this.addSortingFeature();
        } else {

          this.serverError = rateLookupResponse['message'].statusMessage;
        }
      }
  }
  addSortingFeature() {
    this.dataSource.sort = this.sort;
    let columnToBeSort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        default: {
          this.tabelConfig.TableHeaders.some(column => {
            if (property === column.title) {
              if (column.sortColumnAttribute instanceof Object)
                columnToBeSort = column.sortColumnAttribute.key;
              else
                columnToBeSort = column.sortColumnAttribute;
              return true;
            } else {
              columnToBeSort = null;
              return false;
            }
          });
          return item[columnToBeSort].toUpperCase().trim();
        }
      }
    }
  }
  
  checkEditOwnAccess(element){
    if(window.location.href.includes('readonly')){
      if((localStorage.getItem('readonlyeditownaccess')==='true') && (element.email === localStorage.getItem('userName'))){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }

  storeRawValue(primaryText, column){
    // sorting on raw value
    let raw;
    raw = primaryText.split(" ")[0];
    if(column['sortColumnAttribute'].type === 'integer')
      raw = parseInt(raw)
    return raw;
  }
  selectCard(i) {
    if(this.indexNum === i) {
      this.indexNum =-1
    } else {
      this.indexNum = i;
    }
  }
  updatedTitleFn = (title) =>{
    return title.split('<br>').join(" ")
  }
}

export interface NewOrder {
  Cost: any;
  DEST_LOCATION_POSTAL_CODE: string;
  SOURCE_LOCATION_COUNTRY_CODE: string;
  TOTAL_VOLUME: string;
  REFNUM_QUAL_XID: string;
  DEST_LOCATION_COUNTRY_CODE: string;
  ORDER_TYPE_XID: string;
  ORDER_RELEASE_GID: string;
  SOURCE_LOCATION_PROVINCE_CODE: string;
  SOURCE_LOCATION_ADDRESS_LINE: string;
  REFNUM_VALUE: string;
  DEST_LOCATION_ADDRESS_LINE: string;
  EARLY_PICKUP_DATE: string;
  TOTAL_VOLUME_UOM_CODE: string;
  DEST_LOCATION_XID: string;
  DEST_LOCATION_CITY: string;
  SOURCE_LOCATION_NAME: string;
  ITEM_QUANTITY: string;
  SOURCE_LOCATION_XID: string;
  DEST_LOCATION_PROVINCE_CODE: string;
  LATE_DELIVERY_DATE: string;
  DOMAIN_NAME: string;
  DEST_LOCATION_NAME: string;
  SOURCE_LOCATION_CITY: string;
  TOTAL_WEIGHT: string;
  TOTAL_WEIGHT_UOM_CODE: string;
  STATUS_VALUE_XID: string;
  SOURCE_LOCATION_POSTAL_CODE: string;
  ORDER_RELEASE_XID: string;
  INSERT_DATE: string;
  WeightVolumePrimaryText: string;
  WeightVolumeSecondaryText: string;
  InsertdatePrimaryText: string;
  OrderPrimaryText: string;
  OrderSecondaryText: string;
  CustomerPrimaryText: string;
  StatusPrimaryText: string;
  TypePrimaryText: string;
  PickupLocationPrimaryText: string;
  PickupLocationSecondaryText: string;
  PickupDatePrimaryText: string;
  DeliveryLocationPrimaryText: string;
  DeliveryLocationSecondaryText: string;
  DeliveryDatePrimaryText: string;
  actions: string;
}
